(function($) {
  'use strict';

  $(function() {
    var $sliders = $('.Slideshow .Slick[data-autoplay-enabled="true"]');
    var interactionEvents = 'wheel.billboardAutoplay touchstart.billboardAutoplay pointerdown.billboardAutoplay mousedown.billboardAutoplay click.billboardAutoplay keydown.billboardAutoplay';

    if (!$sliders.length) return;
    $(document).off('.slideshowAutoplay');

    function startBillboardAutoplay() {
      $sliders.each(function() {
        var $slider = $(this);
        if (!$slider.hasClass('slick-initialized') || $slider.data('billboard-autoplay-timer')) return;

        var slick = $slider.slick('getSlick');
        if (!slick || slick.slideCount < 2) return;

        var rotationSpeed = parseInt($slider.attr('data-autoplay-speed'), 10) || 3000;
        $slider.slick('slickPause');

        var rotationTimer = window.setInterval(function() {
          if (!document.hidden && $slider.hasClass('slick-initialized')) {
            $slider.slick('slickNext');
          }
        }, rotationSpeed);

        $slider.data('billboard-autoplay-timer', rotationTimer);
      });

      $(document).off(interactionEvents, startBillboardAutoplay);
    }

    $(document).one(interactionEvents, startBillboardAutoplay);
    $sliders.one('afterChange.billboardAutoplay', startBillboardAutoplay);
  });
})(window.jQuery);
